import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { AlertTriangleIcon } from "lucide-react";

interface CancelUploadConfirmationDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
}

export default function CancelUploadConfirmationDialog({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
}: CancelUploadConfirmationDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                            <AlertTriangleIcon className="w-5 h-5 text-red-600 dark:text-red-400" />
                        </div>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            Cancel Upload
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-sm text-gray-600 dark:text-gray-400 space-y-4">
                        <p>
                            Are you sure you want to cancel the bulk upload process?
                        </p>
                        <p>
                            Any files that haven't been processed yet will be skipped. Files that have already been processed will remain in the system.
                        </p>
                    </DialogDescription>
                </DialogHeader>

                <div className="flex gap-3 justify-end mt-4">
                    <Button variant="outline" onClick={onClose} disabled={isLoading}>
                        Keep Processing
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disabled={isLoading}
                        variant="destructive"
                    >
                        {isLoading ? "Cancelling..." : "Cancel Upload"}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
